export const getFileType = (fileName = '') => {
    const ext = fileName.split('.').pop().toLowerCase();
  
    if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(ext)) return 'image';
    if (['pdf'].includes(ext)) return 'pdf';
    // if (['mp4', 'webm'].includes(ext)) return 'video';
    if (['txt'].includes(ext)) return 'text';
  
    return 'other';
  };
  